export default[
	/**
	 * 由Tab关怀页点击科室知识进入的科室知识页
 	*/
	{
		path: "/care/deptKnowledge",
		name: "deptKnowledge",
		component: resolve => require.ensure([], () => resolve(require("@/views/deptKnowledge/dept-knowledge")), "deptKnowledge"),
		meta: {
			title: "科室知识"
		}
	},
	/**
	 * 科室知识页中每一条具体的细节页
 	*/
	{
		path: "/care/deptKnowledgeDteail",
		name: "deptKnowledgeDteail",
		component: resolve => require.ensure([], () => resolve(require("@/views/deptKnowledge/dept-knowledge-detail")), "deptKnowledgeDteail"),
		meta: {
			title: "科室知识"
		}
	}
]



// WEBPACK FOOTER //
// ./src/router/deptKnowledge.js